import { InformationBoxIcon } from './InformationBoxIcon';

/**
 * author: Jeff Anders
 * id 7B6B57AD-05FF-4D58-ADC5-EE9E2DAF5D53
 * name information-box
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-box.svg
 * tags
 * - Settings 
 */
export const InfoBoxIcon = InformationBoxIcon;
export default InfoBoxIcon